'use client';

import { memo, forwardRef } from 'react';
import type { ReactNode, CSSProperties } from 'react';
import { cn } from '../../utils/cn';
import { BlurImage } from '../ui';

export interface CaseCardBaseProps {
  imageUrl: string;
  imagePlaceholder?: string | null;
  alt?: string;
  onClick?: () => void;
  className?: string;
  style?: CSSProperties;
  /** Content displayed at the top (e.g., NEW badge) */
  topSlot?: ReactNode;
  /** Content displayed at the bottom (e.g., price, name) */
  bottomSlot?: ReactNode;
}

const CaseCardBaseComponent = forwardRef<HTMLDivElement, CaseCardBaseProps>(
  (
    {
      imageUrl,
      imagePlaceholder,
      alt,
      onClick,
      className,
      style,
      topSlot,
      bottomSlot,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn('bg-[rgba(30,30,40,0.85)] rounded-2xl p-0 cursor-pointer overflow-hidden aspect-square', className)}
        style={style}
        onClick={onClick}
      >
        <div className="relative w-full h-full">
          <BlurImage
            src={imageUrl}
            placeholder={imagePlaceholder}
            alt={alt || ''}
            className="absolute inset-0"
          />

          {topSlot && <div className="absolute top-2 end-2 z-[1]">{topSlot}</div>}

          {bottomSlot && <div className="absolute bottom-0 start-0 end-0 p-3 flex flex-col items-center gap-1 z-[1]">{bottomSlot}</div>}
        </div>
      </div>
    );
  }
);

CaseCardBaseComponent.displayName = 'CaseCardBase';

export const CaseCardBase = memo(CaseCardBaseComponent);
